import "../polyfill/index";
import "../common/RailsUjs";
import lazyLoad from "../common/LazyLoad";
import pageIndex from "./pages/index";

window.addEventListener("DOMContentLoaded", () => {
  pageIndex();
  lazyLoad();
});
